import Image from 'next/image';
import React from 'react';

import { cx } from '@emotion/css';

import styles from './ContactSalesView.module.scss';

export const ContactSalesView = () => {
  return (
    <section className={styles.how_explore}>
      <div className={cx(styles.container, styles.root)}>
        <div className={styles.explore_Qeeper_support}>
          <h3
            className={cx(
              styles.site_title,
              styles.h3,
              styles.Qeeper_support_site_title,
            )}>
            Discover how Qeeper can support your
            <br /> property management needs
          </h3>
        </div>
        <div className={styles.for_reach}>
          <div className={styles.profile_card}>
            <h5 className={styles.profile_title}>Get in Touch with:</h5>
            <figure className={styles.profile_card_image}>
              <Image
                src="/images/propertyManager/contactSales/qeeper-sales-james.png"
                width={160}
                height={200}
                objectFit={'contain'}
                alt="Qeeper Sales James"
                className={styles.profile_card_image_innr}
              />
            </figure>
            <h4 className={styles.profile_name}>James Catto </h4>
            <div className={styles.card_action}>
              <a
                href="mailto:james@qeeper.co.uk"
                target="_blank"
                className={cx(styles.cstm_a, styles.msg_mail)}>
                <Image
                  src="/images/propertyManager/contactSales/sms.svg"
                  alt="sms icon"
                  width={25}
                  height={24}
                />
                james@qeeper.co.uk 
              </a>
              <a
                href="https://calendly.com/qeeper/newbusinessclients"
                target="_blank"
                className={cx(styles.cstm_a, styles.book_a_call)}>
                <Image
                  src="/images/propertyManager/contactSales/book-call.svg"
                  alt="book call icon"
                  width={29}
                  height={28}
                />
                Schedule a call
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
